import React from 'react';

const PostContentElement = (props) => {
    const {
        content,
        label,
    } = props;

    let contentItems = content.map((item, index) => {
        return (
            <span
                className="alumni-post__content-item-text"
                key={index}
            >{item.text}</span>
        );
    });

    let contentItemsTag = <div className="alumni-post__content-item">
        <p className="alumni-post__content-item-label">{label}</p>
        <p className="alumni-post__content-item-text">
            {contentItems}
        </p>
    </div>

    return contentItemsTag;
}

export default PostContentElement;